(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- mobile menu ---- */
  var burger = document.querySelector('.nav-burger');
  var menu = document.getElementById('mobile-menu');
  function closeMenu() {
    if (!menu || !burger) return;
    menu.classList.remove('open');
    burger.classList.remove('open');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Open menu');
  }
  if (burger && menu) {
    burger.addEventListener('click', function () {
      var o = menu.classList.toggle('open');
      burger.classList.toggle('open', o);
      burger.setAttribute('aria-expanded', String(o));
      burger.setAttribute('aria-label', o ? 'Close menu' : 'Open menu');
    });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
  }

  /* ---- reveals + count-up ---- */
  function countUp(el) {
    var to = parseInt(el.getAttribute('data-to'), 10) || 0;
    if (reduce || to === 0) { el.textContent = to; return; }
    var dur = 1200, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(to * e);
      if (p < 1) requestAnimationFrame(step); else el.textContent = to;
    }
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('in');
          en.target.querySelectorAll('[data-to]').forEach(countUp);
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
    document.querySelectorAll('[data-to]').forEach(function (el) { el.textContent = el.getAttribute('data-to'); });
  }

  /* ---- generic tab groups (formula pillars, home pillar selector) ---- */
  document.querySelectorAll('[data-tabs]').forEach(function (group) {
    var tabs = group.querySelectorAll('[role=tab]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', String(x === t)); });
        var scope = document;
        group.getAttribute('data-tabs') && (scope = document.querySelector('[data-tab-panels="' + group.getAttribute('data-tabs') + '"]') || document);
        scope.querySelectorAll('[role=tabpanel]').forEach(function (g) {
          g.classList.toggle('current', g.id === t.getAttribute('aria-controls'));
        });
      });
    });
  });

  /* ---- qty stepper ---- */
  document.querySelectorAll('.qty-box').forEach(function (box) {
    var input = box.querySelector('input');
    box.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, v + (b.dataset.dir === 'up' ? 1 : -1));
      });
    });
  });

  /* ---- sheen masked to can shape ---- */
  document.querySelectorAll('[data-can-stage]').forEach(function (stage) {
    var canImg = stage.querySelector('[data-can-img]');
    var sheen = stage.querySelector('.fx-sheen');
    if (!canImg || !sheen) return;
    function applySheenMask() {
      var u = 'url("' + (canImg.currentSrc || canImg.src) + '")';
      sheen.style.webkitMaskImage = u; sheen.style.maskImage = u;
      sheen.style.webkitMaskSize = '100% 100%'; sheen.style.maskSize = '100% 100%';
      sheen.style.webkitMaskRepeat = 'no-repeat'; sheen.style.maskRepeat = 'no-repeat';
    }
    if (canImg.complete) applySheenMask(); else canImg.addEventListener('load', applySheenMask);
  });
})();
